import { MediaImageInterface, MediaImageModel } from '@modules/media/models/media-image.model';
import { MediaStreamInterface, MediaStreamModel } from '@modules/media/models/media-stream.model';

import { SectionType } from '../enums/section-type.enum';

import { Section } from './section.model';

export interface StageSectionInterface {
  headline?: string;
  anchor?: string;
  items: {
    title: string;
    topline: string;
    subtitle: string;
    fuelLabel: string;
    media: MediaImageInterface | MediaStreamInterface;
  }[];
}

export interface StageSectionItemInterface {
  title: string;
  subtitle: string;
  fuelLabel: string;
  media: MediaImageModel | MediaStreamModel;
}

export class StageSectionModel implements Section {
  public type = SectionType.STAGE;
  public items: StageSectionItemInterface[];
  public headline?: string;
  public anchor?: string;
  constructor(data: StageSectionInterface) {
    this.headline = data.headline;
    this.anchor = data.anchor;
    this.items = data.items.map((item) => {
      let media: any = null;
      if (item.media) {
        media =
          item.media.type === 'stream'
            ? new MediaStreamModel(item.media as MediaStreamInterface)
            : new MediaImageModel(item.media as MediaImageInterface);
      }
      return {
        topline: item.topline,
        title: item.title,
        subtitle: item.subtitle,
        fuelLabel: item.fuelLabel,
        media,
      };
    });
  }
}
